import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const defaults = { free_shipping_threshold: 69, standard_shipping_cost: 6.9, pickup_address: "Corso Europa 107, Avellino" };
const ShippingContext = createContext(defaults);

export const ShippingProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaults);
  useEffect(() => {
    api.get("/shipping-settings").then(({ data }) => setSettings({ ...defaults, ...data })).catch(() => {});
  }, []);
  return <ShippingContext.Provider value={settings}>{children}</ShippingContext.Provider>;
};

export const useShipping = () => useContext(ShippingContext);
